// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__vWoio","slideIn":"Nav_slideIn__qkf8D","active":"Nav_active__QR1YA"};